import React from "react";
import { Grid, Segment } from "semantic-ui-react";
import { InspectionStatuses } from "../../../citizen-inspection-list/constants/InspectionStatus";
import { ZonedDateTime } from "../../../../../../../components/global_components/ZonedDateTime";
import usePublicInspection from "../../../../../hooks/inspections/public/usePublicInspection";

interface Props {
  id: number | string;
}
export default function PublicInspectionPanelCompletedSegment({ id }: Props) {
  const { data, isLoading, isFetching } = usePublicInspection({ id: id });

  const loading = isLoading || isFetching || !data;
  const status = data?.data.attributes.status;

  if (status !== InspectionStatuses.PASSED && status !== InspectionStatuses.FAILED) {
    return <></>;
  }

  const startedAt = data?.data.attributes.startedAt ?? "";
  const completedAt = data?.data.attributes.completedAt ?? "";

  const formatString = "MMM d, yyyy 'at' h:mm a";

  return (
    <Segment className='tw-px-0' basic loading={loading}>
      <Grid>
        <Grid.Row className='tw-pb-0'>
          <Grid.Column className='tw-font-bold' width={4}>
            Started
          </Grid.Column>
          <Grid.Column width={12}>
            <ZonedDateTime value={startedAt} formatString={formatString} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column className='tw-font-bold' width={4}>
            Completed
          </Grid.Column>
          <Grid.Column width={12}>
            <ZonedDateTime value={completedAt} formatString={formatString} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}
